export const logoutQuery = 'logout';
export const redirectToQuery = 'redirectTo';
export const codeQuery = 'code';
